




import { dateObjToYearFirst, iconPath, formatDollarValue, formatDtypeLabel } from "./basicUtils.js";





export function mapRowsToColumns(rowsParam, columns, startCount=0) {
    try {
        let cnt = startCount;
        let idCnt = 83838;

        // Add 'id' property to rows if absent from record
        const localRows = rowsParam.every(rec => rec?.id) 
            ? rowsParam 
            : rowsParam.map(row => { 
                return row && !row.id 
                    ? {...row, id: `${idCnt++}-${Date.now()}`} 
                    : row; 
            });

        // Map the fields from <rows> so that that each <row.fields> is in the same order as the <column.fieldName>s
        const newRows = localRows.map(record => {
            if (!record || Object.keys(record).length === 0) {
                console.warn(`Skipping record with Id ${record.id}: No fields data available.`);
                return null; // Skip records with no fields
            }
           
            cnt++;

            // Map the <rows> to <localRows> and add 'keyId'/'fieldId' properties to each field
            const fields = columns.map(col => {
                cnt++;
                let field = {
                    keyId: `${cnt}`,
                    fieldId: `${col.fieldName}-${record.id}`,
                    fieldName: col.fieldName,
                    isEditable: col.isEditable || false,
                    /* Format the data type for a nice label
                    label: col.dtype === 'date' || col.dtype === 'datetime' 
                        ? dateObjToYearFirst(record[col.fieldName])
                            : col.dtype === 'currency'
                        ? `${parseFloat(record[col.fieldName]) < 0 ? '-$'+ formatDollarValue(record[col.fieldName]).slice(1) : '$' + formatDollarValue(record[col.fieldName])}`
                            : col.dtype === 'number' || col.dtype === 'decimal'
                        ? `${formatDollarValue(record[col.fieldName])}`
                            : col.dtype === 'percent'
                        ? `${formatDollarValue(record[col.fieldName])}%`
                        
                        : `${record[col.fieldName]}`,*/

                    label: formatDtypeLabel(record, col.fieldName, col.dtype || 'text'),
                    value: record[col.fieldName],
                    dtype: col.dtype || 'text'
                }

                if (col.hasOwnProperty('textClass')) {
                    // Handle custom classes for the field's text 
                    field.textClass = col.textClass(record);
                }
                if (col.hasOwnProperty('fieldIcon')) {
                    // Handle field icons
                    let fieldIcon = col.fieldIcon(record);
                    let isLeft = false;
                    
                    if (fieldIcon) {
                        if (typeof fieldIcon === 'object') {
                            isLeft = fieldIcon.isLeft ? true : false;
                            fieldIcon = fieldIcon.icon;
                        }
                        
                        // Object with 'icon' and 'container' keys
                        let iconPathRes = iconPath(fieldIcon,  true);
                        // Get the custom icon class if any
                        const fieldIconClass = col.hasOwnProperty('fieldIconClass') ? col.fieldIconClass(record) : '';
                        if (fieldIconClass) {
                            iconPathRes.container = 'slds-icon_container';
                        }
                        const svgClass = fieldIconClass ? `slds-icon slds-icon_x-small ${fieldIconClass}` : 'slds-icon slds-icon_small';
                        field.icon = {container: iconPathRes.container, svg: svgClass, icon: iconPathRes.icon, isLeft: isLeft};
                        
                    }   
                }

                return field
            });
            cnt++;

            let idRec = !record.hasOwnProperty('id') || !record.id
                ? `${idCnt++}-${Date.now()}`
                : null;

            return record.children && record.children.length > 0
                ? {
                    children: [...record.children],
                    keyId: `${cnt}`,
                    rowId: idRec ? `${idRec}-row` : `${record.id}-row`,
                    id: idRec ? `${idRec}` : `${record.id}`,
                    fields: fields.map(field => field)
                }
                : {
                    keyId: `${cnt}`,
                    rowId: idRec ? `${idRec}-row` : `${record.id}-row`,
                    id: idRec ? `${idRec}` : `${record.id}`,
                    fields: fields.map(field => field)
                };
            
        });

        return {rows: newRows, count: cnt};

    }catch(error) {
        console.error('parseRowsAndColumns', error)
    }

}


// ====================== Initialize Edit Popover ======================= \\
// Display edit popover when cell is clicked
export function handleEditClick(cmp, event, popoverId) {
    try  {
        const button = event.currentTarget;
        const cell = button.closest('td, th');

        // Get the field name and record id of the clicked cell
        const currentRecordField = button.dataset.fieldId;
        if (!currentRecordField) return;
        

        // Initiate the <popoverEdit> Object
        fieldIdToPopoverEdit(cmp, button.dataset);

        // Get the popover element
        const popover = cmp.template.querySelector('.slds-popover_edit');
    
        if (popover && cell) {
            // Get the clicked cell's bounding rect
            const rect = cell.getBoundingClientRect();

            // Convert absolute coordinates to relative inside the container
            const containerRect = cmp.template.querySelector('.slds-table_edit_container').getBoundingClientRect();
            
            // Get the rect top/left position
            const offsetTop = rect.top - containerRect.top;
            const offsetLeft = rect.left - containerRect.left;
            
            // Convert rect top/left to pixels
            popover.style.top = offsetTop + 'px';
            popover.style.left = offsetLeft + 'px';
            
            // Remove 'hidden' attribute ---++ Add 'show' attribute
            popover.classList.remove('slds-hide');
            popover.classList.add('slds-show');

            // Focus the popover input element
            setTimeout(() => {
                switch(true) {
                    case cmp.popoverEdit.dtype === 'richtext': 
                        popover.querySelector('x-slds-rich-text-editor').focusMe();
                        break;

                    case cmp.popoverEdit.dtype === 'picklist': 
                        popover.querySelector('x-dropdown-plain').focusMe();
                        break;

                    case cmp.popoverEdit.dtype === 'textarea':
                        popover.querySelector('x-slds-input').focusMe();
                        break;

                    default:
                        popover.querySelector('input').focus();
                        break;
                }
            }, 30);
        }
    
    }catch(error) {
        cmp.showToast('tableUtils.js  -->  handleEditClick', error);
    }
}

// use 'childAccessor' property to scan the rows' children to find target record
export function getRecordByChildAccessor(rows, childAccessor, recId) {
    // split childAccessor into parent/child
    const parts = childAccessor.split('-');

    if (parts.length === 1) {
        // Handle Single Parent
        return rows.find(parent => parent.id === childAccessor).children
            .find(child => child.id === recId);
    
    } else if(parts.length === 2) {
        // Handle Two Parents
        return rows.find(parent => parent.id === parts[0].trim()).children
            .find(child => child.id === parts[1].trim()).children
            .find(gChild => gChild.id === recId);
    }
    return null;
}

// Find the record whose field was edit-clicked
export function fieldIdToPopoverEdit(cmp, buttonDataset) {
    try  {
        // Split the dataset.fieldId from the button to get the recordId/fieldName
        const fieldName = buttonDataset.fieldId.split('-')[0]; 
        const recordId = buttonDataset.fieldId.split('-')[1];

        // Get level (parent/child/grandchild)
        const level = buttonDataset.level;    
        // Get the parent Record Ids from dataset.childAccessor
        const childAccessor = buttonDataset.childAccessor || null;

        // Find the record in the <rows> array
        const record = childAccessor
            ? getRecordByChildAccessor(cmp.localRows, childAccessor, recordId) // Handle Child record
            : cmp.localRows.find(rec => rec.id === recordId);                 // Handle Parent record

        if (record) {
            // Find field in <record.fields> array
            const fieldEntry = record.fields.find(f => f.fieldName === fieldName);                
            // Boolean for field's dataType
            const boolProp = `is${fieldEntry.dtype}` || 'isText';

            // use the record.field properties to initiate the <popoverEdit> Object
            cmp.popoverEdit = {
                id: recordId,
                fieldName: fieldEntry.fieldName, 
                label: fieldEntry.label, 
                value: fieldEntry.value, 
                dtype: fieldEntry.dtype,
                fieldId: buttonDataset.fieldId,
                rowAccessor: childAccessor,
                [boolProp]:  true,
            };

            // Store the recordId and fieldName of the entry in case popover closes too early
            cmp.popoverEditCopy = {id: recordId, fieldName: fieldEntry.fieldName};

            // Find the columns belonging to the field
            const colLevel = level === '3' ? 'Three' : level === '2' ? 'Two' : 'One';

            if (fieldEntry.dtype === 'picklist') {
                // Get the picklist options for the field
                cmp.picklistOptions = cmp[`level${colLevel}Columns`].find(col => col.fieldName === fieldEntry.fieldName).options
            }
        }

    }catch(error) {
        cmp.showToast('tableUtils.js --> fieldIdToPopoverEdit', error);
    }
}
// ======================================================================= \\



// Remove the popover from the DOM
export function removeEditPopover(cmp, isClearPopoverEdit=false) {
    try {
        const popover = cmp.template.querySelector('.slds-popover_edit'); 
        if (popover) {
            popover.classList.add('slds-hide');
            popover.classList.remove('slds-show');
        }
        if (isClearPopoverEdit) {
            cmp.popoverEdit.isEdited = false;
            finishLocalEdit(cmp);
            cmp.popoverEdit = {};
        }
    
    }catch(error) {tableUtils.js
        cmp.showToast('tableUtils.js --> removeEditPopover', error);
    }
}


// Map fields in <originalDraftValues> back to the record 
export function revertRecFields(draftObj, rec) {
    return rec.fields.map(field => {
        const draftField = draftObj[field.fieldName];
        return draftField 
            ? { ...field, label: draftField.label, value: draftField.value }
            : { ...field };
    });
}
//** Return childrens' fields to their original values
export function revertChildren(parent, rowIdsSet, draftOriginalValues) {
    return parent.children.map(c => {
        const isChildEdited = rowIdsSet.has(c.id);
        const isGrandChildEdited = (c.children || []).some(g => rowIdsSet.has(g.id));

        if (!isChildEdited && !isGrandChildEdited) {
            return c;
        }
        
        const draftChild = draftOriginalValues.find(d => d.id === c.id);                   // Get the child record
        const revertedFields = isChildEdited ? revertRecFields(draftChild, c) : c.fields; // Get the Original field values 

        const revertedGrandChildren = (c.children || []).map(g => {
            if (!rowIdsSet.has(g.id)) return g;                                         // Do nothing if grandchild not edited
            const draftGrandChild = draftOriginalValues.find(d => d.id === g.id); // Find the edited grandchild
            return { ...g, fields: revertRecFields(draftGrandChild, g) };        // Return the fields' original values
        });
        
        return {
            ...c,
            fields: revertedFields,
            ...(isGrandChildEdited && { children: revertedGrandChildren })
        };
    });
}
// Map all edited records' fields back to original values
export function cancelEdits(cmp) {
    try {
        // Get ids of edited rows 
        const rowIdsSet = new Set(cmp.draftOriginalValues.map(d => d.id));

        // Update <this.localRows> directly
        cmp.localRows = cmp.localRows.map(parent => {
            const isParentEdited = rowIdsSet.has(parent.id);
            const isChildEdited = (parent.children || []).some(c => rowIdsSet.has(c.id));
            const isGrandChildEdited = (parent.children || []).some(c =>
                (c.children || []).some(g => rowIdsSet.has(g.id))
            );
            
            // Do nothing if the parent and its children were not edited 
            if (!isParentEdited && !isChildEdited && !isGrandChildEdited) return parent;

            // Get the original field values
            const originalFieldsObj = cmp.draftOriginalValues.find(d => d.id === parent.id);

            return {
                ...parent,
                ...(isParentEdited && {
                    fields: revertRecFields(originalFieldsObj, parent) // Handle field edits of parent
                }),
                children: revertChildren(parent, rowIdsSet, cmp.draftOriginalValues) // Handle children/grandchildren with field edits
            };
        });

        // Clear all the Drafts
        clearDrafts(cmp);
             
        cmp.resetClasses();  // Remove slds-is-edited from all cells
        cmp.isTableEdited = false;  // Take the table out of edit-mode

    } catch (error) {
        cmp.showToast('tableUtils.js --> cancelEdits()', error); 
    } 
}
// Clear All Draft Variables
export function clearDrafts(cmp) {
    try {
        cmp.draftOriginalValues = [];
        cmp.draftValues = [];
        if (cmp.popoverEdit) {
            cmp.popoverEdit = {};
        }

    }catch(error) {
        cmp.showToast('tableUtils.js --> clearDrafts', error)
    }
}


// ==================== Calculate Table  Max Height ==================== \\
// Requires: <this.origMaxHeight>, <this.isNewPage> to be in the component
export function handleTableScrollBehavior(cmp, tableCl) {
    console.log('adjusting');
    // Set the container's max  height
    const container = cmp.template.querySelector(`.${tableCl}`);
    if (container) {
        if (cmp.isNewPage) {
            container.scrollTop = 0;
        }
        const maxHeight = calculateMaxHeight(cmp.maxHeight, container);

        if (!cmp.origMaxHeight) {
            cmp.origMaxHeight = maxHeight;
        }

        requestAnimationFrame(() => {
            if (container.offsetHeight > cmp.origMaxHeight) {
                container.style.maxHeight = `${cmp.origMaxHeight}px`;
                container.style.overflowY = 'auto';
            } else {
                container.style.overflowY = 'hidden';
            }
        });   
    }

}
// Convert the argument to pixels (percent, vh or pixels)
export function calculateMaxHeight(value, cmp) {
    if (value.includes('vh')) {
        const vhValue = parseFloat(value);
        return (window.innerHeight * vhValue) / 100;
    } else if (value.includes('px')) {
        return parseFloat(value);
    } else if (value.includes('%')) {
        const availableVh = getAvailableViewportHeight(cmp);
        const percentValue = parseFloat(value);
        return (availableVh * percentValue) / 100;
    }

    console.warn("Unrecognized max-height unit:", value);
    return Infinity;
}
// Get available veiwport if not parent height specified
export function getAvailableViewportHeight(cmp) {
    const hostElement = cmp;

    if (!(hostElement instanceof HTMLElement) || !hostElement.isConnected) {
        console.warn("Host element is not a valid HTMLElement or is not connected");
        return window.innerHeight;
    }

    const bodyHeight = window.innerHeight;
    const siblings = Array.from(hostElement.parentElement?.children || []).filter(el => el !== hostElement);
    const otherComponentsHeight = siblings.reduce((total, el) => total + el.offsetHeight, 0);

    return bodyHeight - otherComponentsHeight;
}
// Set a max height for slds-table elements to trigger
export function handleTableMaxHeight(cmp, containerSelector) {
    const cont = cmp.template.querySelector(containerSelector);
    if (!cont) return;

    const maxHeight = calculateMaxHeight(cmp.maxHeight || 'calc(70vh - 50px)');

    cont.style.maxHeight = `${cmp.isTableEdited ? maxHeight - 65 : maxHeight}px`;

    if (cont.scrollHeight > maxHeight) {
        cont.style.overflowY = 'auto';
    } else {
        cont.style.overflowY = 'hidden';
    }
}
// ====================================================================== \\

// ================== Handle Edit Popover Draft Values ================== \\
// Store the editing field's Original Value
export function storeOriginalDraftValue(recordId, fieldName, value, label, cmp) {
    try {
        // Abort if not required information
        if (!recordId || !fieldName) return;

        // Create the new draft entry
        const draftFieldEntry = { value, label };

        // Get the record if it exists already in <draft OriginalValues> 
        const existingDraftEntry = cmp.draftOriginalValues.find(draft => draft.id === recordId);

        // Add the object directly to the <draft OriginalValues>
        if (!existingDraftEntry) {
            cmp.draftOriginalValues.push( {id: recordId, [fieldName]: draftFieldEntry} ); // push to array
            cmp.draftOriginalValues = cmp.draftOriginalValues.map(d => d);
            return; // Abort
        }

        // Get the existing fieldName entry from <draft OriginalValues> if exists
        const existingFieldEntry = existingDraftEntry[fieldName];

        if (!existingFieldEntry) {
            // Add the field values to the <draftEntry> if not already a key with that fieldName
            existingDraftEntry[fieldName] = draftFieldEntry;
        }

    }catch(error) {
        cmp.showToast('tableUtils.js --> storeOriginalDraftValue', error);
    }
}
// Store the new Edited Value in Draft Values
export function updateDraftValueOnEdit(cmp, customDraft=null) {
    try {
        // Enable a custom draft to be sent
        const currentEdit = customDraft ? customDraft : cmp.popoverEdit;
        
        // Starter entry
        if (cmp.draftValues.length < 1 || !cmp.draftValues.some(rec => rec.id === currentEdit.id)) {
            cmp.draftValues.push({id: currentEdit.id, [currentEdit.fieldName]: currentEdit.value });
            return;
        }
        cmp.draftValues.forEach(draft => {
            if (draft.id === currentEdit.id) {
                draft[currentEdit.fieldName] = currentEdit.value;
            }
        });
    }catch(error) {
        cmp.showToast('tableUtils.js --> updateDraftValueOnEdit', error);
    }
}
// Finalize the popoverEdit process --> set the cell to isEdited (if edited) & focus the cell that was clicked
export function finishLocalEdit(cmp) {
    try {
        if (cmp.checkboxArray && cmp.checkboxArray.length > 0) {
            if (cmp.popoverEdit) {
                //this.renderApplyEditsModal();
            }
        }
        // Get the fieldId to focus the edited cell
        const fieldId = cmp.popoverEdit.fieldId;
        const isEdited = cmp.popoverEdit.isEdited || false;
        const rowAccessor = cmp.popoverEdit.rowAccessor;

        if (cmp.popoverEdit.isEdited) {

            if (!cmp.popoverEdit.fieldId || cmp.popoverEdit.value === undefined) {
                removeEditPopover(cmp, true);
                return;
            }
            
            updateDraftValueOnEdit(cmp);             // Add the edited field's value to the <draftValues> array
            assignPopOverValueToField(cmp, rowAccessor);         // Update the field's value/label of the record that was edited
        }
        // Clear the popoverEdit properties
        cmp.popoverEdit = {};

        // Focus the cell/editbutton and add class 'slds-is-edited' to the edited cell
        focusCellOnEdit(cmp, fieldId, isEdited);
            
    
    }catch(error) {
        cmp.showToast('tableUtils.js --> finishLocalEdit', error);
    }
} 
// Focus the cell that was clicked and set the cell's class to 'slds-is-edited' if the field was edited
export function focusCellOnEdit(cmp, fieldId, isEdited, isFocus=true) {
    try {
        // Get the cell by the fieldId (i.e. <fieldName-recordId>)
        const editedCell = cmp.template.querySelector(`[data-id="${fieldId}"]`);
        if (!editedCell) return;

        // For multi-edit situations
        if (!isFocus) {
            // Only mark the cell as slds-is-edited if isFocus=false
            editedCell.classList.add('slds-is-edited');
            return;
        }

        // Get the cell's edit button
        const button = editedCell.querySelector('.slds-button_icon');

        setTimeout(() => {    
            // Set the cell's tabIndex as 0 to make it focusable 
            editedCell.setAttribute("tabIndex", "0");
            
            // If not edited, just apply the focus
            isEdited ? editedCell.classList.add('slds-is-edited', 'slds-has-focus') : editedCell.classList.add('slds-has-focus');

            // Always focus the button after an edit has completed
            button.classList.add('slds-has-focus');
            button.focus();
            button.closest('td').classList.add('slds-has-focus');
        }, 30);

        if (isEdited && !cmp.isTableEdited) {
            // Display the save/cancel buttons below the table
            cmp.isTableEdited = true;
        }
    
    }catch(error) {
        cmp.showToast('tableUtils.js --> focusCellOnEdit', error);
    }
}
// Update the field with the popoverEdit's value
export function assignPopOverValueToField(cmp, rowAccessor=null, customDraft = null) {
    const currentEdit = customDraft || cmp.popoverEdit;

    try {
        const updateRecord = rec => ({
            ...rec,
            fields: rec.fields.map(field =>
                field.fieldName === currentEdit.fieldName
                    ? {
                        ...field,
                        value: currentEdit.value,
                        label: cmp.popoverEdit.isdatetime || cmp.popoverEdit.isdate
                            ? dateObjToYearFirst(currentEdit.value)
                            : `${currentEdit.value}`
                    }
                    : { ...field }
            )
        });
        if (rowAccessor) {
            // Use <rowAccessor> to find the parent(s)
            const levelOne = rowAccessor.split('-')[0]
            const levelTwo = rowAccessor.split('-').length > 1 ? rowAccessor.split('-')[1] : null;

            if ( 
                (!levelTwo && cmp.localRows.find(r => r.id === levelOne).children
                    .some(c => c.id === currentEdit.id))
            ) {
                // Refresh the rows with the Child field edit
                cmp.localRows = cmp.localRows.map(parent => {
                    if (parent.id !== levelOne) return parent;

                    return {
                        ...parent,
                        children: parent.children.map(child => 
                            child.id === currentEdit.id
                                ? updateRecord(child)
                                : child
                        )
                    }
                });

            } else if (
                levelTwo && cmp.localRows.find(r => r.id === levelOne).children 
                    .find(c => c.id === levelTwo).children
                    .some(g => g.id === currentEdit.id)
            ) {
                // Refresh the rows with the GrandChild field edit
                cmp.localRows = cmp.localRows.map(parent => {
                    if (parent.id !== levelOne) return parent;

                    return {
                        ...parent,
                        children: parent.children.map(child => {
                            if (child.id !== levelTwo) return child;

                            return {
                                ...child,
                                children: child.children.map(grandchild =>
                                    grandchild.id === currentEdit.id
                                        ? updateRecord(grandchild)
                                        : grandchild
                                )
                            };
                        })
                    };
                });
            } 
            return;
        }
        
        if (cmp.localRows.some(rec => rec.id === currentEdit.id)) {
            cmp.localRows = cmp.localRows.map(rec =>
                rec.id === currentEdit.id ? updateRecord(rec) : { ...rec }
            );
        } else {
            const page = Object.keys(cmp.paginatedRows).find(k =>
                cmp.paginatedRows[k].some(rec => rec.id === currentEdit.id)
            );

            if (page) {
                cmp.paginatedRows = {
                    ...cmp.paginatedRows,
                    [page]: cmp.paginatedRows[page].map(rec =>
                        rec.id === currentEdit.id ? updateRecord(rec) : { ...rec }
                    )
                };
            }
        }
    } catch (error) {
        cmp.showToast('tableUtils.js --> assignPopOverValueToField', error);
    }
}

// Get the value sent by the child cmp (<x-slds-input> / <x-dropdown-plain> / <x-slds-rich-text-editor>)
export function handleInputMessage(event, cmp) {
    try  {
        // Get the updated value
        const details = event.detail;
        const val = typeof details === 'object'
            ? details[Object.keys(details)[0]]
            : details;


        // Store the original value if the cell was edited
        if (cmp.popoverEdit && !cmp.popoverEdit.isEdited && cmp.popoverEdit.value != val) {
            cmp.popoverEditCopy.id = cmp.popoverEditCopy.id;
            // Store the original value of the Record's field
            cmp.popoverEdit.isEdited = true;
            storeOriginalDraftValue(cmp.popoverEdit.id, cmp.popoverEdit.fieldName, cmp.popoverEdit.value, cmp.popoverEdit.label, cmp);
        }   

        if (val !== undefined) {
            // Update the popoverEdit's value 
            cmp.popoverEdit.value = val;
            cmp.popoverEdit.label = `${val}` || '';
            cmp.popoverEditCopy.value = val;
            cmp.popoverEditCopy.label = `${val}` || '';
        }

        // Assign the value to the drafts ---++  Clear the popoverEdit
        cmp.finishLocalEdit();
        removeEditPopover(cmp, true);

    }catch(error) {
        cmp.showToast('tableUtils.js --> handleEditInputChange', error);
    }
}

// ======================= Finalize Edit Popover ======================== \\
// If Escape was not pressed --> save the value in editPopover if it differs from the orginal draft
export function inputEleBlur(message=null, cmp) {
    try {
        if (message) {
            removeEditPopover(cmp, true);
            return;
        }
        if (!cmp.isEscape && cmp.popoverEdit && cmp.popoverEdit.isEdited) {
            // If was edited --> Store the new values
            cmp.popoverEditCopy = JSON.parse(JSON.stringify(cmp.popoverEdit));
            finishLocalEdit(cmp);
            return;
        }

        // Clear the popover without adding any edits
        removeEditPopover(cmp, true);
    }catch(error) {
        cmp.showToast('tableUtils.js --> handlePopoverBlur', error);
    }

}


// ======================== Pagination Handlers ========================= \\
// Break the rows up into sections of <itemAmt> if isPaginator=true
export function paginateRows(rowsParam, itemAmt=50) {
    try {
        let pageInfo = {};          // Store info about the pages
        let paginatedRows = {}    // Store each page's rows as a page-number key

        const rowsLength = rowsParam.length;             // Number of rows in dataset
        const pageCount = Math.ceil(rowsLength / itemAmt);   // Number of pages --> round up

        // Add Page count to <pageInfo> object 
        pageInfo.pageCount = pageCount;

        // Create pages of <paginatedRows> (page number as object keys)
        for (let i = 1; i <= pageCount; i++) {
            const startSlice = (i - 1) * itemAmt;
            let endSlice = i * itemAmt;
    
            if (endSlice > rowsLength) {
                endSlice = rowsLength;
            }
            // Item Reference: '<startSlice> to <endSlice>' && Page Reference: '<i> of <rowsLength>'
            pageInfo[`${i}`] = {
                items: `Items ${startSlice + 1} to ${endSlice}`, 
                page: `Page ${i} of ${pageCount}`
            };

            // Copy the slice into <paginated Rows> object
            paginatedRows[`${i}`] = rowsParam.slice(startSlice, endSlice)
                .map(row => ({ ...row }));
        }
        
        // Redefine <rowsParam>
        const localRows = paginatedRows['1'].map(row => ({...row}));

        // Get the current page's info
        pageInfo.activePage = '1';

        return {pageInfo: pageInfo, paginatedRows: paginatedRows};
    
    }catch(err) {
        console.error('tableUtils.js --> paginateRows()', err);
    }
}
// ======================================================================= \\



// ==================== Handle Focus/Blur of Cells ====================== \\
// Focus a cell on click
export function focusCell(event=null, cellParam=null) {
    try {
        const cell = event ? event.currentTarget : cellParam;
        cell.classList.add('slds-has-focus');
        cell.setAttribute("tabindex", "0"); // Make the item focusable
        cell.focus();
    }catch(error) {
        console.error('tableUtils.js --> focusCell', error);
    }
}
// Focus both the cell and the button 
export function focusEditButton(event=null, btnParam=null) {
    try {
        const button = event ? event.currentTarget : btnParam;          // Get the button
        const cell = button.closest('td, th');                         // Get the cell
        button.classList.add('slds-has-focus');                       // Add focus to the button 
        cell.setAttribute("tabIndex", "0");                          // Set the cell's tab index to 0
        cell.classList.add('slds-has-focus');                       // Add focus to the cell
    }catch(error) {
        console.error('tableUtils.js --> focusEditButton', error);
    }
}
// Blur both the cell and the button 
export function blurEditButton(event) {
    try {
        const cell = event.currentTarget.closest('td, th');
        const button = event.currentTarget;
        button.classList.remove('slds-has-focus');
        if (event.relatedTarget && cell.contains(event.relatedTarget)) {
            // Focus is still within the cell; do nothing.
            return;
        }
        cell.classList.remove('slds-has-focus');
        cell.setAttribute("tabIndex", "-1");
    }catch(error) {
        console.error('tableUtils.js --> blurEditButton', error);
    }
}
// Remove slds-has-focus on Blur of Cell
export function blurCell(event) {
    try  {
        const cell = event.currentTarget;
        if (event.relatedTarget && cell.contains(event.relatedTarget)) {
            // Focus is still within the cell; do nothing.
            return;
        }
        cell.setAttribute("tabindex", "-1"); // Make the item focusable
        cell.classList.remove('slds-has-focus');
    }catch(error) {
        console.error('tableUtils.js --> tableUtils.js --> blurCell', error);
    }
}
// ======================================================================= \\
